import { useAppDispatch } from '@core/redux/hooks';
import { RootState } from '@core/redux/reducers';
import {
  deleteEvent,
  getEventById,
  updateEvent,
} from '@features/events/store/events.thunk';
import { usePrograms } from '@hooks';
import { Events } from '@models';
import { PageHeader } from '@organisms';
import { EventDetailTemplate } from '@templates';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';
export const EventDetailPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { normalizeProgramsAndClasseseRequest } = usePrograms();
  const { state }: { state: { id: string } } = useLocation();
  const { eventDetail } = useSelector((state: RootState) => state.events);
  const [enableEdition, setEnableEdition] = useState(false);

  const [formData, setFormData] = useState<Events.EventEditingForm>({});
  const [formDataOriginal, setFormDataOriginal] =
    useState<Events.EventEditingForm>({});

  useEffect(() => {
    if (!state?.id) {
      navigate('/social/gamefication/events');
      return;
    }

    dispatch(getEventById(state.id));
  }, []);

  useEffect(() => {
    if (!eventDetail?.identifier) return;
    setFormDataOriginal(eventDetail);
    setFormData(eventDetail);
  }, [eventDetail]);

  const handleEditFormData = (field: string, value: any) => {
    setFormData(prevState => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleDiscardChanges = () => {
    setFormData(formDataOriginal);
    setEnableEdition(false);
  };

  const handleSaveEdition = async () => {
    const eventsContents = normalizeProgramsAndClasseseRequest(
      formData?.programs || []
    );

    dispatch(
      updateEvent({
        id: eventDetail?.id || 0,
        identifier: formData?.identifier || '',
        name: formData?.name || '',
        description: formData?.description || '',
        eventTypeId: Number(formData?.eventTypeId) || 0,
        statusActivated: formData.statusActivated,
        eventsContents,
        languages: [
          { locale: 'es_ES', description: formData?.description_es || '' },
          { locale: 'en_US', description: formData?.description_en || '' },
          { locale: 'pt_BR', description: formData?.description_pt || '' },
        ],
      } as Events.EventForm)
    );

    setEnableEdition(false);
  };

  const handleDeleteEvent = async () => {
    if (!eventDetail?.identifier) return;
    await dispatch(deleteEvent(eventDetail.identifier));
    navigate('/social/gamefication/events', { replace: true });
  };

  useBreadcrumbs([
    {
      label: 'Eventos',
    },
  ]);

  return (
    <>
      <PageHeader
        backToPath={() => {
          navigate(-1);
        }}
        title={'Gestão de eventos'}
        subTitle={''}
      />

      <EventDetailTemplate
        enableForm={!enableEdition}
        formData={formData}
        handleChange={handleEditFormData}
        handleDeleteEvent={handleDeleteEvent}
        handleSaveEdition={handleSaveEdition}
        handleDiscardEdition={handleDiscardChanges}
        handleEditEvent={() => setEnableEdition(true)}
      />
    </>
  );
};
